const documentViewTypes = {
  computed: {
    types () {
      return {
        documents: 'documents',
        templates: 'templates'
      }
    },
    isDocumentsType () {
      return this.type === this.types.documents
    },
    isTemplatesType () {
      return this.type === this.types.templates
    }
  }
}

export default documentViewTypes
